import React, { useState, useEffect } from 'react';
import './GlobalWhatsApp.css';

const GlobalWhatsApp = () => {
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const whatsappNumber = '919900257351';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowWhatsApp(true);
      } else {
        setShowWhatsApp(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hello! I am interested in your services.');
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <>
      {showWhatsApp && (
        <div className="global-whatsapp-float" onClick={handleWhatsAppClick}>
          <div className="whatsapp-icon">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 0C7.163 0 0 7.163 0 16c0 2.825.737 5.482 2.031 7.794L0 32l8.394-2.019A15.923 15.923 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0z" fill="#25D366"/>
              <path d="M25.5 15.938c0 5.256-4.275 9.531-9.531 9.531a9.49 9.49 0 01-4.544-1.156L6.5 25.5l1.219-4.894A9.49 9.49 0 016.469 16c0-5.256 4.275-9.531 9.531-9.531s9.5 4.275 9.5 9.469z" fill="#fff"/>
              <path d="M20.813 18.281c-.269-.137-1.594-.787-1.844-.875-.25-.088-.431-.137-.613.137-.181.269-.7.875-.856 1.056-.156.181-.313.2-.581.063-.269-.138-1.137-.419-2.169-1.338-.8-.713-1.344-1.594-1.5-1.863-.156-.269-.019-.413.119-.55.125-.119.269-.313.4-.469a1.85 1.85 0 00.269-.45c.075-.137.037-.256-.019-.356-.056-.1-.613-1.475-.838-2.019-.225-.531-.45-.456-.613-.469h-.525c-.181 0-.475.069-.725.338-.25.269-.95.931-.95 2.269s.975 2.631 1.106 2.812c.137.181 1.9 2.9 4.6 4.069.644.275 1.144.438 1.537.562.644.206 1.231.175 1.694.106.519-.075 1.594-.65 1.819-1.281.225-.631.225-1.175.156-1.281-.068-.119-.25-.181-.518-.319z" fill="#25D366"/>
            </svg>
          </div>
          <span className="whatsapp-tooltip">Chat with us</span>
        </div>
      )}
    </>
  );
};

export default GlobalWhatsApp;
